var map = {
	"./args.js": "cf14",
	"./call.js": "71ef",
	"./coupons-share/index.js": "8c57",
	"./course-detail/index.js": "217a",
	"./course-share/index.js": "23e0",
	"./record-share/index.js": "8f5f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "50e5";